import { getOptions } from "utils/fields";

export const getCityProvince = (companyCity = "", provinceId = null) => {
    let cityProvinceLabel = "";

    if (companyCity != "") {
        cityProvinceLabel = companyCity;
    }
    if (provinceId != null) {
        const provLabel =
            getOptions({ fieldKey: "weatherRegion", version: "v11-11" }).find((opt) => opt?.value?.id === provinceId)
                ?.label || "";

        cityProvinceLabel = `${cityProvinceLabel}${cityProvinceLabel !== "" ? ", " : ""}${provLabel}`;
    }
    return cityProvinceLabel;
};

export const getCalcPerformedBy = (userData = {}) => {
    const {
        name: userName = "",
        email = "",
        userMeta: { company = "" } = {},
        userPreferences: {
            companyPhone = "",
            province: { id: provinceId } = {},
            companyAddress = "",
            companyCity = "",
            companyPostalCode = "",
            companyFax = "",
        } = {},
    } = userData;

    const cityProvinceLabel = getCityProvince(companyCity, provinceId);

    return {
        userName,
        company,
        companyAddress,
        cityProvince: cityProvinceLabel,
        companyPostalCode,
        companyPhone,
        companyFax,
        email,
    };
};